// extracted by mini-css-extract-plugin
export default {"loader_container":"styles_loader_container__Lw8dp","loader_item":"styles_loader_item__pqzjV","loaderAnimation":"styles_loaderAnimation__b0MPs"};